import { Card, CardContent } from '~/components/ui/card';
import type { LucideIcon } from 'lucide-react';

interface IMetricCardProps {
  title: string;
  value: number | string;
  icon: LucideIcon;
}

export const MetricCard = ({ title, value, icon: Icon }: IMetricCardProps) => {
  return (
    <Card>
      <CardContent className="p-6">
        <div className="flex items-center gap-4">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary/10">
            <Icon className="h-5 w-5 text-primary" />
          </div>
          <div className="min-w-0">
            <p className="text-sm text-muted-foreground">{title}</p>
            <p className="text-2xl font-bold">{value}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
